import { Link } from 'react-router-dom';
import { VERSION } from '../lib/logger';

// The site-wide copyright / legal / contact strip.
//
// `fixed` (used once, from App.tsx) pins it to the bottom of the viewport
// on every route, desktop only - below the md breakpoint the bottom tab
// bar owns that space and Terms/Privacy/contact are reachable from the
// Legal row in Settings. Every layout adds `md:pb-…` so nothing hides
// behind it.
//
// Without `fixed` it's a plain in-flow footer - the legal pages render one
// at the end of their own long-document shell.
export function AppFooter({ fixed = false }: { fixed?: boolean }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={
        'flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[12px] text-black/40 dark:text-white/40 text-center px-4 ' +
        (fixed
          ? 'hidden md:flex fixed inset-x-0 bottom-0 z-30 py-2.5 border-t border-black/5 dark:border-white/10 bg-[color-mix(in_srgb,var(--color-bg)_90%,transparent)] backdrop-blur-md'
          : 'flex py-6')
      }
    >
      <span>© {year} zmist</span>
      <span aria-hidden="true">·</span>
      <Link to="/terms" className="hover:text-black/70 dark:hover:text-white/70 hover:underline">
        Terms
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/privacy" className="hover:text-black/70 dark:hover:text-white/70 hover:underline">
        Privacy
      </Link>
      <span aria-hidden="true">·</span>
      <a href="mailto:support@zmist.co" className="hover:text-black/70 dark:hover:text-white/70 hover:underline">
        support@zmist.co
      </a>
      <span aria-hidden="true">·</span>
      {/* The exact VITE_APP_VERSION a deploy stamps into the bundle (see
          logger.ts) - same string every console.log line is already
          prefixed with, just visible without opening devtools. Confirms a
          deploy actually reached this browser (vs. a stale cached bundle)
          at a glance. */}
      <span title="Build version">{VERSION}</span>
    </footer>
  );
}
